import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import {
  downloadAllPlayers,
  getPlayerPaymentHistoryByLogin,
  getPlayers,
  getPlayersFeeCollection,
} from "../../../services/academicService";
import RegisterQrModal from "../../components/qr/RegisterQrModal";
import ForgetPasswordModal from "../../components/superAdmin/ForgetPasswordModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PlayerReciptModal from "../../components/PlayerReciptModal";
import AssignCoachModal from "../../components/AssignCoachModal";
import PlayerPaymentModal from "../../components/PlayerPaymentModal";
import PlayerOnlinePaymentModal from "../../components/PlayerOnlinePaymentModal";
import { toast } from "react-toastify";
import PlayerReciptHistoryModal from "../../components/PlayerReciptHistoryModal";

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Invoice No", sortingVale: "invoiceNumber" },
  { heading: "Payment Date", sortingVale: "paymentDate" },
  { heading: "Receipt Number", sortingVale: "receiptNumber" },
  { heading: "UTR Number", sortingVale: "utrNumber" },
  { heading: "Payment Type", sortingVale: "paymentType" },
  { heading: "Package", sortingVale: "package" },
  { heading: "Amount", sortingVale: "amount" },
  { heading: "Download", sortingVale: "download" },
];

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const PlayerPaymentHistory = () => {
  const [forgetModal, setForgetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);

  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [qrCodeModal, setQrCodeModal] = useState(false);
  const [currentStart, setCurrentStart] = useState(0);
  const [paymentModal, setPaymentModal] = useState(false);
  const [onlinePaymentModal, setOnlinePaymentModal] = useState(false);
  const [reciptModal, setReciptModal] = useState(false);
  const [assignCoachModal, setAssignCoachModal] = useState(false);
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [selectedHistory, setSelectedHistory] = useState(null);

  // ---- API CALL WITH page, size, search ----
  async function fetchUserData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getPlayerPaymentHistoryByLogin(page, size, search);
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({ page, size, search });
  }, [page, size, search]);

  // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "email":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "landLine":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.landLine || "").localeCompare(b.landLine || "")
            : (b.landLine || "").localeCompare(a.landLine || ""),
        );
        break;

      case "phone":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.phone || "").localeCompare(b.phone || "")
            : (b.phone || "").localeCompare(a.phone || ""),
        );
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  return (
    <>
      <PageTitle activeMenu={"Payment History"} motherMenu={"Player"} />
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Payment History</h4>
                  </div>
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="justify-content-between d-sm-flex mb-3">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder=""
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE WITH HORIZONTAL SCROLL */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{currentStart * size + ind + 1}</td>
                                  <td>{data?.invoiceNumber}</td>
                                  <td>
                                    {data?.paymentDate
                                      ? new Date(
                                          data.paymentDate,
                                        ).toLocaleString()
                                      : "-"}
                                  </td>
                                  <td>{data?.receiptNumber}</td>
                                  <td>{data?.utrNumber}</td>

                                  <td>{data?.paymentType}</td>
                                  <td>
                                    {data?.subscription?.packageType?.name}
                                  </td>
                                  <td>{data?.amount}</td>
                                  <td>
                                    <i
                                      className="fa-solid fa-download"
                                      role="button"
                                      title="Download selected payment"
                                      onClick={() => {
                                        setSelectedHistory(data);
                                        setReciptModal(true);
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData.length === 0 && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${
                              page === 0 ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${
                              page + 1 >= totalPages ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
      <PlayerReciptHistoryModal
        show={reciptModal}
        onClose={() => setReciptModal(false)}
        userData={selectedHistory}
        onPaymentSuccess={() => {
          setReciptModal(false);
        }}
      />
    </>
  );
};

export default PlayerPaymentHistory;
